import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'shared/components/Button/Button';
import { ModalContent } from 'shared/components/Modal/ModalContent';
import { useSignOut } from 'shared/hooks/useSignOut';

interface SignOutModalProps {
  onClose: () => void;
}

export const SignOutModal: FC<SignOutModalProps> = ({ onClose }) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'modal:signOut',
  });

  const [signOutUser, loading] = useSignOut();

  return (
    <ModalContent className="max-w-[640px]" name="signOutModal" title={t('title')}>
      <div className="grid gap-4 pt-4 md:grid-cols-2 md:gap-6">
        <Button
          disabled={loading}
          variant="outline"
          color="black"
          name="signOutCancelButton"
          onClick={onClose}
        >
          {t('closeAction')}
        </Button>
        <Button
          className="row-start-1 md:row-start-auto"
          loading={loading}
          disabled={loading}
          name="signOutConfirmButton"
          onClick={signOutUser}
        >
          {t('confirmAction')}
        </Button>
      </div>
    </ModalContent>
  );
};
